<template>
    <div class="gift-header">
        <div class="logo">
            <router-link to="home">
                <img src="../assets/img/gift/Logo.png">
            </router-link>
        </div>
    </div>
    <div class="gift-child-layout">
        <router-view />
    </div>
    <div class="gift-footer">
        <hr>
        <div class="footer-item">
            © Online Learning Hub 2021
        </div>
        <span class="footer-pc">
            <div class="footer-item middle">
                Terms of Use
            </div>
            <div class="footer-item right">
                Privacy Policy
            </div>
        </span>
        <div class="footer-mobile">
            Terms of Use | Privacy Policy
        </div>
    </div>
</template>

<script>
    export default {
        name: "Gift Header",
        data() {
            return {
            }
        },
        methods: {
        },
        watch: {
            $route(to, from) {
                if(from.name == 'GiftPayment' && to.name == 'GiftHome'){
                    document.body.classList.remove("el-popup-parent--hidden");
                    document.body.style.paddingRight = "0";
                }
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/GiftHeader.scss";
    @import "../styles/mobile/GiftHeader.scss";
</style>
